import {
  FETCH_PLANS_REQUEST,
  FETCH_PLANS_SUCCESS,
  FETCH_PLANS_FAILURE,
  CREATE_PLAN_REQUEST,
  CREATE_PLAN_SUCCESS,
  CREATE_PLAN_FAILURE,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_FAILURE,
  DELETE_PLAN_REQUEST,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILURE,
  ALLOCATE_DRIVER_PLAN_REQUEST,
  ALLOCATE_DRIVER_PLAN_SUCCESS,
  ALLOCATE_DRIVER_PLAN_FAILURE,
} from "../actions/types";

const initialState = {
  plans: [],
  allocatedPlan: null,
  loading: false,
  error: null,
  message: "",
};

const packagePlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLANS_REQUEST:
    case CREATE_PLAN_REQUEST:
    case UPDATE_PLAN_REQUEST:
    case DELETE_PLAN_REQUEST:
      return { ...state, loading: true, error: null, message: "" };

    case FETCH_PLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: action.payload,
        message: "Plans loaded successfully",
        error: null,
      };

    case CREATE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: [...state.plans, action.payload],
        message: "Plan created successfully",
        error: null,
      };

    case UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: state.plans.map((plan) =>
          plan.kilometer_package_id === action.payload.kilometer_package_id
            ? action.payload
            : plan
        ),
        message: "Plan updated successfully",
        error: null,
      };

    case DELETE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plans: state.plans.filter(
          (plan) => plan.kilometer_package_id !== action.payload
        ),
        message: "Plan deleted successfully",
        error: null,
      };

    case FETCH_PLANS_FAILURE:
    case CREATE_PLAN_FAILURE:
    case UPDATE_PLAN_FAILURE:
    case DELETE_PLAN_FAILURE:
      return { ...state, loading: false, error: action.payload, message: "" };

    case ALLOCATE_DRIVER_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: "",
      };

    case ALLOCATE_DRIVER_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        allocatedPlan: action.payload,
        message:
          "Driver deliveries allocated successfully",
        error: null,
      };

    case ALLOCATE_DRIVER_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: "",
      };
    default:
      return state;
  }
};

export default packagePlanReducer;
